import { render } from "./LayerFootPage.vue?vue&type=template&id=4a9d0262&scoped=true"
import script from "./LayerFootPage.vue?vue&type=script&lang=js"
export * from "./LayerFootPage.vue?vue&type=script&lang=js"

import "./LayerFootPage.vue?vue&type=style&index=0&id=4a9d0262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9d0262"]])

export default __exports__